import { toast } from "react-hot-toast"

import { setLoading, setToken } from "../../redux/slices/authSlice"
import { resetCart } from "../../redux/slices/cartSlice"
import { setUser } from "../../redux/slices/profileSlice"
import { apiConnector } from "../apiConnector"
import { endpoints } from "../apis"
import emailjs from "@emailjs/browser";
import { otpTemplate } from "../../mailTemplates/emailVerificationTemplate"
import { resetPasswordTemplate } from "../../mailTemplates/Resetpassword"

const {
  SENDOTP_API,
  SIGNUP_API,
  LOGIN_API,
  RESETPASSTOKEN_API,
  RESETPASSWORD_API,
} = endpoints;

export function sendOtp(email, navigate) {
  return async (dispatch) => {
    const toastId = toast.loading("Loading...")
    dispatch(setLoading(true))
    try {
      const response = await apiConnector("POST", SENDOTP_API, {email})
      
      // console.log("SENDOTP API RESPONSE............", response)

      // console.log(response.data.success);

      const message = response.data.message;

      if(message === "User already exists"){
        toast.error("Sign Up Failed, User already Exists");
        dispatch(setLoading(false));
        toast.dismiss(toastId);
        return;
      }

      if (!response.data.success) {
        throw new Error(response.data.message)
      }

      // console.log("response object otp", response?.data?.otp)
      /** SEND EMAIL FROM FRONTEND USING EMAILJS */
     await emailjs.send(
        process.env.REACT_APP_EMAILJS_SERVICE_ID,
        process.env.REACT_APP_EMAILJS_TEMPLATE_ID,
        {
          email: email,
          subject: "OTP for your StudyCraze account Authentication",
          message_html: otpTemplate(response?.data?.otp),   // IMPORTANT
        },
        process.env.REACT_APP_EMAILJS_PUBLIC_ID
      );

      toast.success("OTP Sent Successfully")
      navigate("/verify-email")
    } catch (error) {
      // console.log("SENDOTP API ERROR............", error)
      toast.error("Could Not Send OTP")
    }
    dispatch(setLoading(false))
    toast.dismiss(toastId)
  }
}

export function signUp(
  accountType,
  firstName,
  lastName,
  email,
  password,
  confirmPassword,
  otp,
  navigate
) {
  return async (dispatch) => {
    const toastId = toast.loading("Loading...")
    dispatch(setLoading(true))
    try {
      const response = await apiConnector("POST", SIGNUP_API, {
        accountType,
        firstName,
        lastName,
        email,
        password,
        confirmPassword,
        otp,
        navigate
      })

      // console.log("SIGNUP API RESPONSE............", response)

      const message = response.data.message;

      if(message === "Invalid OTP" || message === "OTP not valid"){
       if(message === "Invalid OTP"){
          toast.error("Wrong OTP, Please Try again");
        }
       if(message === "OTP not valid"){
          toast.error("OTP is not valid");
        }
        dispatch(setLoading(false))
        toast.dismiss(toastId);
        return;
      }

      if (!response.data.success) {
        throw new Error(response.data.message)
      }
      toast.success("Signup Successful")
      // navigate("/login")

      //--- from here ----//
      dispatch(setToken(response.data.token))
      const userImage = response.data?.user?.image
        ? response.data.user.image
        : `https://api.dicebear.com/5.x/initials/svg?seed=${response.data.user.firstName} ${response.data.user.lastName}`
      dispatch(setUser({ ...response.data.user, image: userImage }))
      localStorage.setItem("token", JSON.stringify(response.data.token))
      localStorage.setItem("user", JSON.stringify(response.data.user))
      navigate("/dashboard/my-profile")
      ///---- upto here ---// the code is written so that user automatically get logged in when sign up
      
    } catch (error) {
      // console.log("SIGNUP API ERROR............", error)
      toast.error("Signup Failed")
      navigate("/signup")
    }
    dispatch(setLoading(false))
    toast.dismiss(toastId)
  }
}

export function login(email, password, navigate) {
  return async (dispatch) => {
    const toastId = toast.loading("Loading...")
    dispatch(setLoading(true))
    try {
      const response = await apiConnector("POST", LOGIN_API, {
        email,
        password,
      })

      // console.log("LOGIN API RESPONSE............", response)

      const message = response.data.message;

      if(message === "User is not registered, please try again" || message === "Password is incorrect"){
        if(message === "User is not registered, please try again"){
          toast.error("User not registered, Login Failed");
        }
        else if(message === "Password is incorrect"){
          toast.error("Incorrect Password");
        }
        dispatch(setLoading(false))
        toast.dismiss(toastId);
        return;
      }

      if (!response.data.success) {
        throw new Error(response.data.message)
      }

      toast.success("Login Successful")
      dispatch(setToken(response.data.token))
      const userImage = response.data?.user?.image
        ? response.data.user.image
        : `https://api.dicebear.com/5.x/initials/svg?seed=${response.data.user.firstName} ${response.data.user.lastName}`
      dispatch(setUser({ ...response.data.user, image: userImage }))
      localStorage.setItem("token", JSON.stringify(response.data.token))
      localStorage.setItem("user", JSON.stringify(response.data.user))
      navigate("/dashboard/my-profile")
    } catch (error) {
      // console.log("LOGIN API ERROR............", error)
      toast.error("Login Failed")
    }
    dispatch(setLoading(false))
    toast.dismiss(toastId)
  }
}

export function logout(navigate) {
  return (dispatch) => {
    dispatch(setToken(null))
    dispatch(setUser(null))
    dispatch(resetCart())
    localStorage.removeItem("token")
    localStorage.removeItem("user")
    toast.success("Logged Out")
    navigate("/")
  }
}

export function getPasswordResetToken(email, setEmailSent) {
  return async(dispatch) => {
    dispatch(setLoading(true));
    try {
      const response = await apiConnector("POST", RESETPASSTOKEN_API, {email});
      // console.log("RESET PASSWORD TOKEN RESPONSE...", response);

      const message = response.data.message;
      if(message === "Your Email is not registered with us"){
        toast.error(message);
        dispatch(setLoading(false));
        return ;
      }
      
      if(!response.data.success){
        throw new Error(response.data.message);
      }

      await emailjs.send(
        process.env.REACT_APP_EMAILJS_SERVICE_ID,
        process.env.REACT_APP_EMAILJS_TEMPLATE_ID,
        {
          email: email,
          subject: "Reset your password",
          message_html: resetPasswordTemplate(response?.data?.url, email),
        },
        process.env.REACT_APP_EMAILJS_PUBLIC_ID
      );

      toast.success("Reset Email Sent");
      setEmailSent(true);

    } 
    catch (error) {
      // console.log("RESET PASSWORD TOKEN Error ", error);
      toast.error('Failed to Update Password');
    }
    dispatch(setLoading(false));
  }
}

export function resetPassword(password, confirmPassword, token, navigate){
  return async(dispatch) =>{
    dispatch(setLoading(true));
    try{
      const response = await apiConnector('POST', RESETPASSWORD_API, {password, confirmPassword, token});

      // console.log("RESET Password RESPONSE ...", response);

      const message = response.data.message;
      // console.log(message);
      if(message === "Token is invalid" || message === "Token is expired, please regenerate token"){
        toast.error('Session Expired');
        navigate('/login');
        dispatch(setLoading(false))
        return;
      }

      if(!response.data.success){
        throw new Error(response.data.message);
      }

      toast.success("Password has been reset successfully");
      navigate('/login');
    }
    catch(error){
      // console.log("RESET PASSWORD TOKEN Error", error);
      toast.error("Unable to Reset Password");
    }
    dispatch(setLoading(false));
  }
} 
